// containers/EstimatesAdmin/parts/MetaCard.jsx
import React from 'react';
import { clamp } from './math';

export default function MetaCard({ meta, data, onPatch, agreementTemplate }) {
    return (
        <div className="card">
            <div className="row cols-2">
                <div><label>Компания</label><input value={meta.company || ''} onChange={(e) => onPatch({ meta: { ...meta, company: e.target.value } })} /></div>
                <div><label>Сайт</label><input value={meta.site || ''} onChange={(e) => onPatch({ meta: { ...meta, site: e.target.value } })} /></div>
            </div>

            <div className="row cols-2" style={{ marginTop: 8 }}>
                <div><label>Заказчик</label><input value={meta.client || ''} onChange={(e) => onPatch({ meta: { ...meta, client: e.target.value } })} /></div>
                <div className="row cols-2">
                    <div><label>Документ №</label><input value={meta.docnum || ''} onChange={(e) => onPatch({ meta: { ...meta, docnum: e.target.value } })} /></div>
                    <div><label>Дата</label><input type="date" value={meta.date || ''} onChange={(e) => onPatch({ meta: { ...meta, date: e.target.value } })} /></div>
                </div>
            </div>

            <div className="row cols-2" style={{ marginTop: 8 }}>
                <div><label>ФИО Подрядчика</label><input value={meta.fioContractor || ''} onChange={(e) => onPatch({ meta: { ...meta, fioContractor: e.target.value } })} /></div>
                <div><label>ФИО Заказчика</label><input value={meta.fioCustomer || ''} onChange={(e) => onPatch({ meta: { ...meta, fioCustomer: e.target.value } })} /></div>
            </div>

            {/* Скрыть доп. соглашение + проценты */}
            <div className="row cols-2" style={{ marginTop: 8 }}>
                <div className="muted">
                    <label>
                        <input
                            type="checkbox"
                            checked={!meta.withAgreement /* галка = скрыть */}
                            onChange={(e) => {
                                const hide = e.target.checked;
                                const next = {
                                    ...meta,
                                    withAgreement: !hide,
                                    agreementText: hide
                                        ? ""
                                        : (meta.agreementText && meta.agreementText.trim())
                                            ? meta.agreementText
                                            : agreementTemplate(meta, meta.company || data.company),
                                };
                                onPatch({ meta: next });
                            }}
                        />{' '}
                        Скрыть доп. соглашение
                    </label>
                </div>

                <div className="row cols-2">
                    <div><label>Наценка %, орг.</label><input value={meta.markup || 0} onChange={(e) => onPatch({ meta: { ...meta, markup: clamp(e.target.value) } })} /></div>
                    <div><label>Скидка %</label><input value={meta.discount || 0} onChange={(e) => onPatch({ meta: { ...meta, discount: clamp(e.target.value) } })} /></div>
                </div>
            </div>

            <div className="row cols-2" style={{ marginTop: 8 }}>
                <div className="muted">
                    <label>
                        <input
                            type="checkbox"
                            checked={!!meta.hideMarkup}
                            onChange={(e) => onPatch({ meta: { ...meta, hideMarkup: e.target.checked } })}
                        />{' '}
                        Спрятать наценку (раскидать по работам)
                    </label>
                </div>
                <div className="muted">Автосохранение включено</div>
            </div>

            <label style={{ marginTop: 8 }}>Доп. соглашение</label>
            <textarea
                rows={4}
                disabled={!meta.withAgreement}
                placeholder={agreementTemplate(meta, meta.company || data.company)}
                value={meta.agreementText || ''}
                onChange={(e) => onPatch({ meta: { ...meta, agreementText: e.target.value } })}
            />
        </div>
    );
}
